/**
 * Hazmat PROs must carry HAZ-MAT PAPERWORK before they can be scheduled.
 *
 * One rule, consumed by the scheduler's Finalize modal, the LC Finalize Prepull
 * pre-check, and the grids' "NO HAZ DOCS" flag. Mirrors
 * backend/app/services/hazmat_paperwork_rule.py: the backend sets
 * `is_missing_haz_docs` only when `hazmat = 'Y'` and no non-deleted
 * HAZ-MAT PAPERWORK document exists for the PRO.
 *
 * Design: docs/plans/2026-10-29-hazmat-paperwork-finalize-gate-design.md
 */

export const SCHEDULING_MISSING_HAZ_DOCS_TOOLTIP =
  'Missing Hazmat Paperwork. Haz=Y orders need a HAZ-MAT PAPERWORK document uploaded; Finalize is blocked until it is.';

export const SCHEDULING_MISSING_HAZ_DOCS_HELP =
  'Hazmat paperwork is required on Haz=Y orders. Upload the HAZ-MAT PAPERWORK document on the order before scheduling.';

/**
 * Scheduler rows: the backend only sets `is_missing_haz_docs` for Haz=Y PROs,
 * but re-check the Haz flag here so a stale payload can never block a
 * non-hazmat finalize.
 */
export function legBlockedForMissingHazDocs(leg: {
  is_hazmat?: boolean;
  is_missing_haz_docs?: boolean;
}): boolean {
  return !!leg.is_hazmat && !!leg.is_missing_haz_docs;
}
